import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, FullRow, TextButton, Column, CustomModal, FullBox, TextField, Typography, makeStyles } from 'seagull';
import { useLocaleKeys } from '~/i18n';
const useStyles = makeStyles({
    content: {
        padding: 16
    },
    footer: {
        justifyContent: 'center',
        gap: 16
    }
});
const validateRoutingNumber = (routingNumber)=>{
    if (routingNumber.length === 9) {
        const d1 = parseInt(routingNumber[0]);
        const d2 = parseInt(routingNumber[1]);
        const d3 = parseInt(routingNumber[2]);
        const d4 = parseInt(routingNumber[3]);
        const d5 = parseInt(routingNumber[4]);
        const d6 = parseInt(routingNumber[5]);
        const d7 = parseInt(routingNumber[6]);
        const d8 = parseInt(routingNumber[7]);
        const d9 = parseInt(routingNumber[8]);
        const checksum = 3 * (d1 + d4 + d7) + 7 * (d2 + d5 + d8) + (d3 + d6 + d9);
        if (checksum % 10 === 0) {
            return null;
        } else {
            return 'Incorrect routing number';
        }
    } else {
        return 'Routing number must be 9 characters long';
    }
};
export const BankAccountDetailsModal = (param)=>{
    let { onCancel, onSubmit } = param;
    const { t: bankAccountDetailsTexts } = useLocaleKeys('components.bankAccountDetails');
    const { t: commonTexts } = useLocaleKeys('common');
    const styles = useStyles();
    const [routingNumber, setRoutingNumber] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [routingNumberError, setRoutingNumberError] = useState(null);
    const [accountNumberError, setAccountNumberError] = useState(null);
    const handleRoutingNumberChange = (event)=>{
        const value = event.target.value;
        setRoutingNumber(value);
        setRoutingNumberError(validateRoutingNumber(value));
    };
    const handleAccountNumberChange = (event)=>{
        const value = event.target.value;
        setAccountNumber(value);
        setAccountNumberError(value ? null : 'Empty account number');
    };
    const handleSubmit = ()=>{
        const routingError = validateRoutingNumber(routingNumber);
        if (routingError) {
            setRoutingNumberError(routingError);
        }
        if (accountNumber === '') {
            setAccountNumberError('Empty account number');
        }
        if (!routingError && accountNumber !== '') {
            onSubmit({
                routingNumber,
                accountNumber
            });
        }
    };
    return /*#__PURE__*/ _jsx(CustomModal, {
        bi: {
            closeButton: {
                name: 'bank_account_details_modal_close'
            }
        },
        maxWidth: 600,
        header: /*#__PURE__*/ _jsx(Typography, {
            variant: "h5",
            children: bankAccountDetailsTexts.title()
        }),
        footer: /*#__PURE__*/ _jsxs(FullRow, {
            className: styles.footer,
            children: [
                /*#__PURE__*/ _jsx(TextButton, {
                    bi: {
                        name: 'cancel_bank_account_setup'
                    },
                    underline: "none",
                    onClick: onCancel,
                    testId: "bank-account-cancel-button",
                    children: commonTexts.buttons.cancel()
                }),
                /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'submit_bank_account_details'
                    },
                    skin: "primary",
                    testId: "bank-account-submit-button",
                    disabled: routingNumberError !== null || accountNumberError !== null,
                    onClick: handleSubmit,
                    children: commonTexts.buttons.submit()
                })
            ]
        }),
        onClose: onCancel,
        children: /*#__PURE__*/ _jsx(Column, {
            className: styles.content,
            children: /*#__PURE__*/ _jsxs(FullBox, {
                centered: true,
                gap: 16,
                children: [
                    /*#__PURE__*/ _jsx(TextField, {
                        bi: {
                            name: 'routing_number'
                        },
                        collapseHelperText: false,
                        required: true,
                        fullWidth: true,
                        label: bankAccountDetailsTexts.routingNumber(),
                        testId: "bank-account-routing-number-input",
                        value: routingNumber,
                        error: routingNumberError !== null,
                        helperText: routingNumberError !== null && routingNumberError !== void 0 ? routingNumberError : '',
                        onChange: handleRoutingNumberChange
                    }),
                    /*#__PURE__*/ _jsx(TextField, {
                        bi: {
                            name: 'account_number'
                        },
                        collapseHelperText: false,
                        required: true,
                        fullWidth: true,
                        label: bankAccountDetailsTexts.accountNumber(),
                        testId: "bank-account-account-number-input",
                        value: accountNumber,
                        error: accountNumberError !== null,
                        helperText: accountNumberError !== null && accountNumberError !== void 0 ? accountNumberError : '',
                        onChange: handleAccountNumberChange
                    })
                ]
            })
        })
    });
};
